import { render, staticRenderFns } from "./TheSwapLayout.vue?vue&type=template&id=5be50e3f"
import script from "./TheSwapLayout.vue?vue&type=script&lang=js"
export * from "./TheSwapLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports